import { useSelector } from 'react-redux';
import { getUserRole } from 'redux/sagas/auth/selectors';
import { USER_ROLES } from '../constants';

export const useIsStaff = () => {
  const userRole = useSelector(getUserRole);

  return userRole !== USER_ROLES.BROKER;
};
